export const excelFileSettings = {
    fileName: 'FORT',
    fileExtension: 'xlsx',
    paperSize: 9,
};
